import type {SubAgent} from '@github-ui/agent-sessions-types/sub-agent'
import {fetchCAPI} from '../capi/fetch-capi'
import {useCAPIQuery} from '../capi/use-capi-query'

export function useSubAgents({repo, enabled}: {repo?: {owner: string; nameOnly: string}; enabled?: boolean}) {
  const owner = repo?.owner
  const name = repo?.nameOnly
  const query = useCAPIQuery<SubAgent[]>({
    enabled: Boolean(owner && name) && (enabled ?? true),
    queryKey: ['custom-agents', owner, name],
    queryFn: async () => {
      if (!owner || !name) {
        return []
      }

      try {
        const response = await fetchCAPI({
          path: `/agents/swe/custom-agents/${owner}/${name}`,
          retryOn401: true,
        })

        if (response.status === 404) {
          return []
        }

        const data = await response.json()
        const agents = data.agents as SubAgent[]

        return agents
      } catch {
        return []
      }
    },
  })

  return query
}
